import './index.less';

import {
  Box,
  Button,
  Icon,
  Space,
  Text,
  TonicProps,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { ChevronLeftIcon } from '@tonic-one/react-icons';
import { useTranslation } from 'react-i18next';

export default function NavBack(
  props: {
    className?: string;
    fixed?: boolean;
    onBack?: () => void;
    style?: any;
  } & TonicProps
) {
  const {
    className = '',
    fixed = true,
    //eslint-disable-next-line @typescript-eslint/no-empty-function
    onBack = () => {},
    style = {},
    ...tonicProps
  } = props;
  // i18n
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();
  return (
    <Box
      className={`navBack ${className}`}
      position={fixed ? 'fixed' : 'static'}
      style={style}
      {...tonicProps}
    >
      <Button
        variant="ghost"
        onClick={onBack}
        className="backBtn"
        color={colorStyle.color.secondary}
        _selected={colorStyle.text.selection}
      >
        <Icon as={ChevronLeftIcon} fontWeight="bold" />
        <Space width="2x" />
        <Text fontSize={16}>{t('reportCommon.buttons.back')}</Text>
      </Button>
    </Box>
  );
}
